import { Button, Dialog, Row } from "@narmi/design_system";
import CsrfTokenMiddleware from "cerulean/src/CsrfTokenMiddleware";
import FileUploader from "cerulean/src/FileUploader";

import { useState } from "react";
import { importProductsFromFile } from "../api";
import { useNotificationContext } from "cerulean/src/NotificationContext";

interface Props {
  kind?: "primary" | "secondary";
  showButton?: boolean;
  isOpen?: boolean;
  onClose?: () => void;
}

const ImportFromFileModal = ({
  kind = "primary",
  showButton = false,
  isOpen: onMenuModalOpen,
  onClose: onMenuModalClose,
}: Props) => {
  const { sendSuccessNotification, sendNegativeNotification } = useNotificationContext();

  const [buttonModalOpen, setButtonModalOpen] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  const isOpen = onMenuModalOpen !== undefined ? onMenuModalOpen : buttonModalOpen;
  const onClose =
    onMenuModalClose !== undefined ? onMenuModalClose : () => setButtonModalOpen(false);
  const openModal = () => setButtonModalOpen(true);

  const actions = (
    <div style={{ float: "right" }} className="padding--right">
      <Row alignItems="center">
        <Row.Item shrink>
          <Button onClick={onClose} kind="negative" label="Cancel" />
        </Row.Item>
        <Row.Item shrink>
          <CsrfTokenMiddleware />
          <Button
            onClick={async () => {
              if (!file) {
                sendNegativeNotification("Please upload a file.");
                return;
              }
              const response = await importProductsFromFile(file);

              if (!response?.ok) {
                sendNegativeNotification("Failed to import products.");
                return;
              }
              onClose();
              sendSuccessNotification("Products imported successfully.");
              setTimeout(() => {
                window.location.href = "/product_list_manager";
              }, 200);
            }}
            label="Yes, import products"
          />
        </Row.Item>
      </Row>
    </div>
  );
  return (
    <>
      {showButton && <Button onClick={openModal} kind={kind} label="Import product list" />}
      <Dialog
        isOpen={isOpen}
        title="Import products"
        footer={actions}
        onUserDismiss={onClose}
        width="600px"
      >
        <div className="fontWeight--semibold fontSize--m fontColor--heading margin--y--l">
          To get started, download the product list in your preferred format. Next, upload the
          downloaded file below.
        </div>
        <div className="margin--top--l fontColor--secondary fontSize--s">
          Note: this will replace any existing product list for both Online and Staff-led flows.
          Product Bundles will not be migrated and will need to be recreated.
        </div>
        <div className="margin--top--l margin--y--xl">
          <FileUploader
            value={file?.name}
            sendRequest={(uploadedFile: File) => setFile(uploadedFile)}
            onChange={() => undefined}
            expand
          />
        </div>
      </Dialog>
    </>
  );
};

export default ImportFromFileModal;
